import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { AngularFireAuth } from 'angularfire2/auth';
import {
  AngularFirestore,
  AngularFirestoreDocument,
} from 'angularfire2/firestore';
import * as firebase from 'firebase';
import { User, Roles } from './user';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/switchMap';

@Injectable()
export class AuthService {
  user: Observable<User>;
  currentUser: Object;
  constructor(
    private afAuth: AngularFireAuth,
    private afs: AngularFirestore,
    private router: Router,
  ) {
    //// Get auth data, then get firestore user document || null
    this.user = this.afAuth.authState.switchMap((user) => {
      if (user) {
        return this.afs.doc<User>(`users/${user.uid}`).valueChanges();
      } else {
        return Observable.of(null);
      }
    });
  }
  getCurrentUser() {
    return this.user;
  }
  emailLogin(email: string, password: string, errorCallBack?) {
    return this.afAuth.auth
      .signInWithEmailAndPassword(email, password)
      .then((user) => {
        // this.afs.firestore.settings({
        //   timestampsInSnapshots: true,
        // })
        return this.updateUserData(user); // if using firestore
      })
      .catch((error) => {
        if (errorCallBack) {
          errorCallBack(error);
        }
        this.handleError(error)
      });
  }

  resetPassword(email: string) {
    const afAuthLocal = this.afAuth;
    return afAuthLocal.auth
      .sendPasswordResetEmail(email);
  }

  private oAuthLogin(provider) {
    return this.afAuth.auth.signInWithPopup(provider).then((credential) => {
      this.updateUserData(credential.user);
    });
  }

  updateUserData(user) {
    // Sets user data to firestore on login
    this.currentUser = user;
    const userRef: AngularFirestoreDocument<any> = this.afs.doc(
      `users/${user.uid}`,
    );

    const data: User = {
      uid: user.uid,
      email: user.email,
      roles: {
        subscriber: true,
      },
    };
    return userRef.set(data, { merge: true });
  }

  signOut() {
    this.currentUser = null;
    this.afAuth.auth.signOut().then(() => {
      this.router.navigate(['/']);
    });
  }
  private handleError(error: Error) {
    console.error(error);
  }

  setPersistentState(value) {
    if (value) {
      console.log('true');
      return this.afAuth.auth.setPersistence(
        firebase.auth.Auth.Persistence.LOCAL,
      );
    } else {
      return this.afAuth.auth.setPersistence(
        firebase.auth.Auth.Persistence.SESSION,
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/core/auth.service.ts